export const IS_AUTH = 'IS_AUTH';
export const OUTPUT_IMAGES = 'OUTPUT_IMAGES';
export const CAMERA_DATA = 'CAMERA_DATA';
export const QUESTIONS_DATA = 'QUESTIONS_DATA';
